import React from "react";
import styled from "@emotion/styled";

const StyledDiv = styled.div`
  /* border: 2px solid purple; */

  min-height: calc(100vh - 4rem);
  margin-top: 4rem;
  box-sizing: border-box;
  background-color: #fcfcfc;

  .image {
    width: 300px;
    margin: 3rem auto 1.2rem auto;
  }

  .page-header {
    /* border: 2px solid lightblue; */
    font-family: "Roboto";
    font-weight: 500;
    font-size: 2rem;
    margin: 0 auto 1rem auto;

    .header-bold {
      color: #00a5e0;
    }
  }

  .sub-header {
    /* border: 2px solid magenta; */
    font-size: medium;
    font-weight: 500;
    font-family: "Roboto";
    margin: 0 auto;
    width: 60%;
  }
`;

const IMG_SRC =
  "https://uploads-ssl.webflow.com/606f59a06712dbd97ef84dee/6100fb5a2eb5c48b5d5dccb9_gif-vini%20(1).gif";

const SuccessPage: React.FC = () => {
  return (
    <StyledDiv>
      <div className="content-container">
        <img className="image" src={IMG_SRC} />
        <h3 className="page-header">Uhul! Deu Tudo certo...</h3>
        <p className="sub-header">
          Você vai receber em breve uma cópia do contrato assinado por email.
          Vamos começar sua jornada de saúde e bem-estar com a Ana? Confere no
          WhatsApp a mensagem de boas-vindas que a sua equipe de saúde preparou
          pra você!
        </p>
      </div>
    </StyledDiv>
  );
};

export default SuccessPage;
